import { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useUrl } from "@shopify/hydrogen/client";
import navigationMenu from "../menu_collections.json";
import NavSearch from "../searchModal/index.client";
import AvaNavItems from "./navigationItems";
import CartModal from "../../cart/modal/index.client";
import { useStoreCart, checkNav } from "../../../store/modules/client";
import {
  NaviconSearch,
  NaviconCart,
  HeaderWishlistIcon,
  GiantIcon1,
  LocationMark1,
  LivLogoAuthorized,
  LivLogoAuthorizedWhiteLogo,
} from "../../elements/Icon";
import AvamobileNav from "../mobile/navigation.client";
import { useWishlist } from "../../../store/modules/client";

const giantWebsiteUrl = "https://giant-bicycles.co.za";

const AvaNav = () => {
  const { pathname: pathName } = useUrl();
  const {
    quantity,
    getNewQuantity,
    cartModal,
    toggelCart,
    openCartNav,
    showSearchState,
    showMobileNavState,
    toggelShowSearch,
    toggelShowSearchFalse,
    toggelCartFalse,
    showMobileNavStateToggle,
    toggleMobileNavFalse,
  } = useStoreCart();

  const { fetchYourWishlist, livWishlist } = useWishlist();
  useEffect(() => {
    fetchYourWishlist();
  }, [livWishlist?.length]);

  const [showMobileBikesMenu, setShowMobileBikesMenu] = useState(false);
  const [showMobileGearsMenu, setShowMobileGearsMenu] = useState("");

  const searchNav = useRef();
  const toggleSearch = () => {
    searchNav.current.classList.add("flex");
    searchNav.current.classList.remove("hidden");
    toggelCartFalse();
    toggelShowSearch();
    mobileNav && mobileNav.current.classList.add("translate-x-[100%]");
    toggleMobileNavFalse();
    if (showSearchState == true) {
      searchNav.current.classList.add("hidden");
      searchNav.current.classList.remove("flex");
    }
  };

  const closeSearch = () => {
    toggelShowSearchFalse();
    document.body.classList.toggle("overflow-hidden");
  };

  const toggleCartModal = (event) => {
    event.preventDefault();
    toggelCart();
    toggelShowSearchFalse();
    toggleMobileNavFalse();
    mobileNav.current.classList.add("translate-x-[100%]");
    if (searchNav && searchNav.current) {
      searchNav.current.classList.remove("flex");
      searchNav.current.classList.add("hidden");
    }
  };

  const toggleCloseCart = (event) => {
    event.preventDefault();
    toggelCartFalse();
    toggleMobileNavFalse();
    toggelShowSearchFalse();
  };

  const mobileNav = useRef();
  const mobileSearchNav = useRef();

  const toggleMobileNav = (e) => {
    e.preventDefault();
    setShowMobileBikesMenu(false);
    setShowMobileGearsMenu(false);
    toggelCartFalse();
    toggelShowSearchFalse();
    showMobileNavStateToggle();
    mobileNav.current.classList.toggle("translate-x-[100%]");
    if (searchNav && searchNav.current) {
      searchNav.current.classList.remove("flex");
      searchNav.current.classList.add("hidden");
    }
  };
  // todo remove this line
  const [show, setShow] = useState(false);
  const [active, setActive] = useState();
  const scrollNav = () => {
    if (window.scrollY > 50) {
      setShow(true);
    } else {
      setShow(false);
    }
  };
  const closeNav = (value) => {
    setActive(value);
  };
  useEffect(() => {
    window.addEventListener("scroll", scrollNav);
    return () => {
      window.removeEventListener("scroll", scrollNav);
    };
  }, []);

  useEffect(() => {
    document.body.classList.remove("overflow-hidden");
  }, [pathName]);

  const { pathname } = useUrl();
  return (
    <>
      <CartModal
        cartModal={cartModal}
        getNewQuantity={getNewQuantity}
        openCartNav={openCartNav}
        toggleCloseCart={toggleCloseCart}
        showMobileNavState={showMobileNavState}
      />
      <NavSearch
        searchNav={searchNav}
        toggleSearch={toggleSearch}
        showSearchState={showSearchState}
        show={show}
        searchHandler={closeSearch}
      />
      <div
        className={`flex flex-row items-center justify-between h-full w-full  mx-auto px-10 sticky z-[60] right-0 left-0 top-0 ${
          pathname === "/dashboard" ? "block h-[50px] bg-[#570054]" : "hidden"
        }`}
      >
        <Link className="pr-2 -ml-4 text-white " to="/" target="_blank">
          <LivLogoAuthorizedWhiteLogo />
        </Link>
      </div>
      <nav
        className={`border-[#e5e7eb] border-b-2   sticky top-0  z-[60] h-[90px] transition-all duration-150  ease-in-out ${
          show ? "w-full  -translate-y-[40px]" : "translate-y-0"
        }  ${pathname === "/dashboard" ? "hidden" : "md:flex  md:flex-col hidden"}   `}
      >
        <div
          className={`bg-[#F9F9FA] transition-all duration-150 md:flex hidden w-full h-[40px] `}
        >
          <div className="flex flex-row items-center justify-between h-full max-w-[1220px] w-10/12 mx-auto ">
            <a href={giantWebsiteUrl} className="px-1 pr-2 " target="_blank">
              <GiantIcon1 />
            </a>

            <Link
              to="/store-locator"
              className="flex flex-row items-center text[#7B7B7B] "
            >
              <LocationMark1 />
              <br />
              <h4 className="uppercase  text-[12px] text-[#7B7B7B] flex items-center pl-2 helveticaFont ">
                Find a Liv store
              </h4>
            </Link>
          </div>
        </div>
        <div
          className={`text-sm md:block hidden bg-white h-[50px] z-[60] ease-in-out  w-full transition-all duration-100  `}
        >
          <div className="flex flex-row items-center h-[50px]  max-w-[1220px] w-10/12 mx-auto">
            <a href="/">
              <LivLogoAuthorized />
            </a>

            <div className="flex items-center justify-center w-full h-full">
              {navigationMenu.map((collection) => {
                collection.pathName = pathName;
                return (
                  <div
                    className="h-full flex flex-row justify-center items-center text-[13px] xl:px-10 px-5"
                    key={collection.id}
                    onMouseEnter={() => {
                      setActive(collection.id);
                    }}
                    onMouseLeave={() => {
                      setActive(null);
                    }}
                  >
                    <a
                      href={collection.handle}
                      className={`${
                        checkNav(collection)
                          ? "text-[#570054] font-gotham-bold"
                          : "text-[#2A3238] font-gotham-light nav-item-hover"
                      } transition-all min-h-full justify-center items-center flex relative`}
                      onClick={() => {
                        closeNav(null);
                      }}
                    >
                      <span
                        before={collection.title}
                        className={`opacity-100 visible before:absolute before:content-[attr(before)] before:font-gotham-bold before:w-full before:h-full before:uppercase before:opacity-0`}
                      >
                        {collection.title}
                      </span>
                    </a>

                    <AvaNavItems
                      closeNav={closeNav}
                      collections={collection.collections}
                      toggleScroll={show}
                      active={active}
                      id={collection.id}
                    />
                  </div>
                );
              })}
            </div>
            <div className="flex flex-col h-full gap-3 font-sans">
              <div className="flex items-center justify-center h-full">
                <div className="">
                  <Link to="/wishlist">
                    <div className="relative w-[50px] flex justify-center items-center">
                      <HeaderWishlistIcon />
                      {livWishlist?.length > 0 && (
                        <span className="flex justify-center items-center bg-[#570054] h-5 w-5 rounded-full text-white absolute right-1 -top-3">
                          {livWishlist?.length}
                        </span>
                      )}
                    </div>
                  </Link>
                </div>

                <div
                  className={`${
                    showSearchState && "bg-[#B8B8B859]"
                  } h-full w-[50px]`}
                >
                  <button
                    onClick={(e) => toggleSearch(e)}
                    className="relative flex items-center justify-center w-full h-full mx-auto"
                  >
                    <label
                      htmlFor="searchInput"
                      className="flex items-center justify-center w-full h-full cursor-pointer"
                    >
                      <NaviconSearch
                        color={showSearchState === true ? "#120A8F" : "#2A3238"}
                      />
                    </label>
                  </button>
                </div>
                <div className="items-center justify-start hidden h-full">
                  <div
                    onClick={toggleCartModal}
                    className="relative w-[50px] flex justify-center items-center"
                  >
                    {quantity > 0 ? (
                      <div className="flex justify-center items-center bg-[#570054] h-5 w-5 rounded-full text-white absolute right-1 -top-3">
                        <p>{quantity}</p>
                      </div>
                    ) : (
                      ""
                    )}
                    <NaviconCart />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <AvamobileNav
        mobileSearchNav={mobileSearchNav}
        mobileNav={mobileNav}
        showMobileNavState={showMobileNavState}
        toggleMobileNav={toggleMobileNav}
        toggleSearch={toggleSearch}
        toggleCartModal={toggleCartModal}
        showSearchState={showSearchState}
        quantity={quantity}
        setShowMobileBikesMenu={setShowMobileBikesMenu}
        setShowMobileGearsMenu={setShowMobileGearsMenu}
        showMobileBikesMenu={showMobileBikesMenu}
        showMobileGearsMenu={showMobileGearsMenu}
      />
    </>
  );
};

export default AvaNav;
